import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { DialogsService } from 'app/services/dialog.service';
import { StatisticsService } from 'app/services/estadisticas.service';
import { AppState } from 'app/store/app.reducer';

@Component({
    selector: 'app-status-bar',
    templateUrl: './status-bar.component.html',
    styleUrls: ['./status-bar.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatDividerModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
    ],
})
// Recordar que este componente solo funciona dentro del layout "ClassicComponent"
export class StatusBarComponent {
    personalStats = { day: 0, week: 0, month: 0, hour: 0 };
    surveyStats = { satisfaction: 0, responseQuantity: 0 };
    userEmail: string;
    internalNumber: number;
    lastUpdate: string;
    lastUpdateDate: Date;
    userRole: string;
    userGroup: string;

    constructor(
        private _store: Store<AppState>,
        private estadisticaServicio: StatisticsService,
        private dialogSvc: DialogsService
    ) {}

    ngOnInit() {
        this._store.select('auth').subscribe((auth) => {
            this.userEmail = auth.auth.userEmail;
            this.internalNumber = auth.auth.internalNumber;
            this.userRole = auth.auth.userRole;
            this.userGroup = auth.auth.userGroup;
            console.log(this.userEmail, this.internalNumber);
        });
        if(this.userRole.includes('ADMIN') || !this.userGroup.includes('ITC')){
            return;
        }
        this.getEstadisticas();
        setInterval(() => {
            this.getEstadisticas();
        }, 3600000);
    }

    getEstadisticas() {
        if (this.userEmail != null) {
            this.lastUpdateDate = new Date();
            this.lastUpdate =
                this.lastUpdateDate.getDate() +
                '/' +
                (this.lastUpdateDate.getMonth() + 1) +
                '/' +
                this.lastUpdateDate.getFullYear() +
                ' ' +
                this.lastUpdateDate.getHours() +
                ':' +
                this.lastUpdateDate.getMinutes();

            // obtener estadísticas del último mes
            const fechaActual = new Date(2025, 12, 31);
            const fechaDesde = new Date(
                fechaActual.getFullYear(),
                fechaActual.getMonth(),
                1
            );
            const fechaHasta = new Date(
                fechaActual.getFullYear(),
                fechaActual.getMonth() + 1,
                0
            );
            const fechaDesdeFormatted: string = `${fechaDesde.getFullYear()}-${
                fechaDesde.getMonth() + 1
            }-${fechaDesde.getDate()}`;
            const fechaHastaFormatted: string = `${fechaHasta.getFullYear()}-${
                fechaHasta.getMonth() + 1
            }-${fechaHasta.getDate()}`;

            console.log(fechaDesde, fechaHasta);
            this.estadisticaServicio
                .getSatisfactionAndAnsweredSurveys({
                    fechaDesde: fechaDesdeFormatted,
                    fechaHasta: fechaHastaFormatted,
                    operadorId: null,
                    tipoEstadistica: 0,
                })
                .then((data) => {
                    console.log({data});

                    this.surveyStats = {
                        ...this.surveyStats,
                        satisfaction: data.tableData[0].valorFinal,
                    }
                });
            this.estadisticaServicio
                .getSatisfactionAndAnsweredSurveys({
                    fechaDesde: fechaDesdeFormatted,
                    fechaHasta: fechaHastaFormatted,
                    operadorId: null,
                    tipoEstadistica: 1,
                })
                .then((data) => {
                    console.log({data});

                    this.surveyStats = {
                        ...this.surveyStats,
                        responseQuantity: data.tableData[0].valorFinal
                    }
                });
            this.estadisticaServicio
                .getCallStatisticsBasedInUser(this.internalNumber)
                .then((data) => {
                    this.personalStats = {
                        day: data.response.isoDay.percentage,
                        week: data.response.isoWeek.percentage,
                        month: data.response.isoMonth.percentage,
                        hour: data.response.isoHour.percentage,
                    }
                })
        } else {
            this.dialogSvc.error(
                'Error',
                'No se pudo obtener el correo del usuario'
            );
        }
    }
}
